export const m = {
  // 操作提示
  selectFileTip: "Please select file",
  selectIncorrectTip: "Please select correct ",
  incorrectTip: "Please input correct ",
  emptyTip: " cannot be empty",
  editTip: "Edited successfully",
  createdTip: "Created successfully",
  sentTip: "Sent successfully",
  secondPsdDifferentTip:
    "The password and confirmation password are inconsistent",
  deleteConfirmTip: "Are you sure to delete ",
  deletedTip: "Deleted successfully",
  uploadedTip: "Uploaded successfully",
  savedTip: "Saved successfully",
  searchTip: "Search",
  dataException: "Data exception",
  planConflictTip: "The plan was added successfully. Please note that this plan conflicts with the previously added plan, and it should be addressed promptly.",
  // 校验规则
  passwordErrorTip:
    "The password cannot have Chinese characters and must be 5-20 in length",
  // 按钮
  cancelBtn: "Cancel",
  confirmBtn: "Confirm",
  createBtn: "Create",
  nextBtn: "Next",
  add: "Add",
  saveBtn: "Save",
  completeBtn: "Complete",
  reset: "Reset",
  filter: "Filter",
  edit: "Edit",
  delete: "Delete",
  // 登录页面
  loginTip: "Please login",
  email: "Email",
  password: "Password",
  signIn: "Sign in",
  login: "Login",
  forgetPsd: "Forgot Password",
  securityCode: "Security Code",
  verfication: "Verfication",
  send: "Send",
  loginNewPsd: "New Password",
  confirmNewPsd: "Confirm New Password",
  return: "Return",
  emailErrorTip: "Please enter correct email",
  // 首页
  sites: "Sites",
  batteryPower: "Battery Power",
  batteryCapacity: "Battery Capacity",
  // 联系客服提示
  allFuncTip:
    "Thank you for your experience. If you want to use all the functions, you can contact us or fill in your email, and we will contact you as soon as possible.",
  ourContact: "Our Contact Information",
  yourEmail: "Your Email",
  submit: "Submit",
  remark: "Description",
  // 用户功能
  funcUserInfo: "User Info",
  funcChangePsd: "Change Password",
  funcLoginOut: "Sign Out",
  setUserInfo: "Personal Information Settings",
  userName: "Username",
  userPhone: "Phone",
  userRemark: "Remarks",
  setSaveBtn: "Save",
  changePsdTitle: "Change Password",
  originPsd: "Origin Password",
  newPsd: "New Password",
  confirmPsd: "Confirm New Password",
  // 站点数据
  region: "Region",
  resampleRule: "Resample Rule",
  assetsManagement: "ASSET MANAGEMENT",
  modes: "Modes",
  events: "Events",
  operations: "Operations",
  dashboard: "Dashboard",
  Configuration: "Configuration",
  charger: "Charger",
  charging: "Charging",
  discharging: "Discharging",
  batteryCharging: "Battery Charging",
  batteryDischarging: "Battery Discharging",
  fromBattery: "From Battery",
  fromSolar: "From Solar",
  fromGrid: "From Grid",
  BESS: "BESS",
  hourlyBattery: "Hourly Battery",
  // 电价折线图
  tariff: "Tariff",
  importTariff: "Import Tariff",
  exportTariff: "Export Tariff",
  chargersTariff: "Chargers Tariff",
  volume: "Volume",
  // 天气折线图
  globalRadiation: "Global Radiation",
  cloud: "Cloud",
  weatherTemperature: "Temperature",
  // 站点编辑
  siteScene: "Scene Type",
  assetType: "Asset Type",
  assetESAdd: "Battery",
  assetES: "Battery",
  energyStorage: "Energy Storage",
  photovoltaic: "Solar",
  load: "Appliance load",
  siteName: "Site Name",
  siteType: "Site Type",
  owner: "Owner",
  longitude: "Longitude",
  latitude: "Latitude",
  longitudeAndLatitude: "Longitude & Latitude",
  timeZone: "Timezone",
  powerSupplier: "Power Supplier",
  maxImportCapacity: "Maximum Import Capacity",
  maxExportCapacity: "Maximum Export Capacity",
  SEGUnitRate: "SEG Unit Rate",
  tariffPeriod: "Tariff Price",
  siteAddress: "Site Address",
  importMPAN: "Import MPAN",
  exportMPAN: "Export MPAN",
  importMPRN: "Import MPRN",
  exportMPRN: "Export MPRN",
  applicationType: "Application Type",
  cannotRepeatTip: " cannot be repeated",
  MPAN: "MPAN",
  MPRN: "MPRN",
  alias: "Alias",
  capacity: "Capacity",
  wholeSale: "WholeSale",
  // 储能
  maximumChargingRatedPower: "Maximum Charging Rated Power",
  maximumDischargingRatedPower: "Maximum Discharging Rated Power",
  warrantyCyclesNumber: "Warranty Cycle Numbers",
  maxDailyCycle: "Maximum Daily Cycle",
  coolingTime: "Cooling Time",
  operatingTemperature: "Operating Temperature",
  beginSoc: "Begin SOC",
  endSoc: "End SOC",
  mdr: "Mdr",
  model: "Model",
  // 光伏
  solarPanelsNumber: "Solar Panels",
  solarPanelsRatedPower: "Solar Panels Rated Power",
  firstYearDegradationRate: "First-year Degradation Rate",
  linearDegradationRate: "Linear Degradation Rate",
  // 资产
  maxChargingPower: "Maximum Charging Power",
  connector: "Connector",
  connectorName: "Connector Name",
  thirdDeviceId: "Third Device ID",
  maximumRatedPower: "Maximum Rated Power",
  chargerName: "Charger Name",
  DCModulePower: "DC Module Power",
  productModel: "Product Model",
  schedulePredictionTime: "Scheduling Prediction Time",
  setAssetParam: "Params Setting",
  setAssetTariff: "Tariff Setting",
  setAssetSchedule: "OUTAGE",
  all: "All",
  assetName: "Name",
  installedCapacity: "Installed Capacity",
  assetStatus: "Status",
  ratedPower: "Nominal Power",
  distance: "Distance ",
  expectedIncome: "Expected Income",
  dailyCycle: "Daily Cycle",
  data: "Data View",
  emptyDataTip: "No Data",
  view: "Display",
  power: "kw",
  unitRatedPower: "Unit Nominal Power",
  pvPanelNum: "Number of Photovoltaic Panels",
  totalRatedPower: "Total Nominal Power",
  firstYearAttenuation: "First Year Attenuation",
  linearAttenuationRate: "Linear Attenuation Rate",
  loadAssetType: "Load Type",
  pvPowerGeneration: "Solar",
  solar: "Solar",
  Battery: "Battery",
  Grid: "Grid",
  estimatedLoad: "Site Load",
  energyStorageChargeAndDischarge: "Dispatch",
  day: "Day",
  night: "Night",
  todayText: "Today",
  backToday: "Back today",
  limitAssetNumTip: "Please add at least one asset",
  chargingPower: "Charging Power",
  availableForEV: "Available for EV",
  charged: "Charging",
  utilisation: "Utilisation",
  number: "Number",
  meterName: "Meter Name",
  meterNumber: "Meter Number",
  meterType: "Meter Type",
  supplier: "Supplier",
  timeRange: "Period",
  // 充电桩信息
  chargingPile: "Charging Terminal",
  chargingPileConnectors: "Number of Connectors",
  chargingPileTariffPeriod: "Charging Rariff Period",
  chargingPileNo: "No.",
  chargingPilePower: "Power",
  // 资产参数
  serialNumber: "Serial Number",
  equipmentManufacturer: "Manufacturer",
  omOperator: "O&M Operator",
  assetOwner: "Asset Owners",
  assetNo: "Asset No",
  country: "Country",
  area: "Region",
  address: "Address of Assets",
  assetLongitude: "Longitude of Assets",
  assetLatitude: "Latitude of Assets",
  assetTimezone: "Time zone of Assets",
  voltage: "Voltage",
  dno: "DNO",
  type: "Type",
  projectApplicationCategory: "Project Application Category",
  cycleEfficiency: "Charge Discharge Cycle Efficienc",
  warrantyPeriod: "Warranty Period",
  attenuationCurve: "SOH",
  lifeCycleCycles: "Total Cycles",
  temperature: "Operating Temperature",
  maxTemperature: "Maximum Operating Temperature",
  minTemperature: "Minimum Operating Temperature",
  minDayCycles: "Minimum Daily Cycle",
  maxDayCycles: "Maximum Daily Cycle",
  operationTime: "Operation Time",
  operationStatus: "Operation Status",
  unitYear: "Years",
  pileName: "Charging Terminal Name",
  pileNo: "Charging Terminal No",
  pileManufacturer: "Charging Terminal Manufacturer",
  pileSerialNo: "Charging Terminal Serial Number",
  gunNo: "Charging Connector No",
  gunSerialNumber: "Charging Connector Serial Number",
  gunPower: "Charging Connector Power",
  gunSort: "Charging Connector Sort",
  rateACDC: "RATE AC/DC",
  rateDCDC: "RATE DC/DC",
  RTE: "RTE",
  loadName: "Load Name",
  loadModel: "Load Model",
  loadType: "Load Type",
  asset: "Asset",
  information: "Information",
  jobActive: "Job Active",
  systemType: "System Type",
  defaultExecutionMode: "Default Mode",
  pcsPower: "PCS Power",
  aggregator: "Aggregator",
  IOTAccountId: "IOT Account ID",
  IOTDeviceIdForDataQuer: "IOT Device ID for Data Query",
  IOTDeviceIdForCommandIssuance: "IOT Device ID for Command Issuance",
  cpo: "CPO",
  // 账单页
  selectTime: "Select Time",
  gained: "Achieved Benefits",
  unrealisedBenefits: "Unrealised Benefits",
  tenYearsExpectGained: "Life Time Expected Benefits",
  returnOfInvestment: "Return On Investment",
  expectGained: "Expected Revenue",
  recovered: "Recovered",
  totalInvestment: "Total Investment",
  importCapacity: "Import Capacity",
  exportCapacity: "Export Capacity",
  lastMonth: "Last Month",
  lastThreeMonths: "Last 3 Months",
  lastSixMonths: "Last 6 Months",
  thisYear: "This Year",
  totalBenefits: "Total Benefits",
  chargingRevenues: "Charging Revenues",
  exportRevenues: "Export Revenues",
  estimatedSavings: "Estimated Savings",
  ancillaryServiceRevenues: "Ancillary Service Revenues",
  chargingRevenuesDescription: "The earnings obtained from EV charging minus the estimated cost of import electricity increase from the grid due to the charging stations.",
  exportRevenuesDescription: "The revenues obtained from power generation to grid.",
  estimatedSavingsDescription: "The savings from using solar power generation for load and charging stations, as well as self-consumption with battery energy storage, are not reflected in your bill. Therefore, the value provided is an estimate.",
  statements: "Statements",
  importCost: "Import cost",
  statement: "Statement",
  importStatement: "Import Statement",
  exportStatement: "Export Statement",
  chargingStatement: "Charging Statement",
  estimatedSavingCalculation: "Estimated Saving Calculation",
  // 账单管理
  selectDate: "Select Date",
  billManage: "Bill Management",
  billList: "Bill List",
  bill: "Bill",
  statementDate: "Statement Date",
  billType: "Bill Type",
  billName: "Bill Name",
  uploadDate: "Upload Date",
  uploadBill: "Upload Bill",
  sizeMaxTip: "The file size cannot exceed 10M",
  // 计划
  site: "Site",
  system: "System",
  startDate: "Start Date",
  mode: "Mode",
  plan: "Plan",
  desc: "Desc",
  timeBetween: "Time Between",
  repetition: "Repetition",
  endDate: "End Date",
  weekly: "Weekly",
  total: "Total",
  ultraFastCharging: "Ultra Fast Charging",
  ancillaryService: "Ancillary Service",
  energySaving: "Energy Saving",
  benefits: "Benefits",
  dailyPlan: "Daily Plan",
  recurringPlan: "Recurring Plan",
  state: "State",
  date: "Date",
  period: "Period",
  event: "Event",
  performance: "Performance",
  startTime: "Start Time",
  endTime: "End Time",
  // 系统
  systemName: "System Name",
  // dashboard
  totalChargingRevenue: "Total Charging Revenue",
  assetData: "Asset Data",
  soc: "SOC",
  totalCharge: "Total Charge",
  hourlyCharge: "Hourly Charge",
  totalCharging: "EV Charging",
  totalAvailableCharge: "Total Available Charge",
  utilisationRate: "Utilisation Rate",
  totalDischarge: "Total Discharge",
  totalPVGenerate: "Total Solar Generation",
  totalAppliancesElectricity: "Total Appliance Load",
  liveMonitor: "Live Monitor",
  chargingStatus: "Charging Terminal Status",
  free: "Free",
  reserved: "Reserved",
  offLine: "Off-line",
  faulted: "Faulted",
  siteLoad: "Hourly Load",
  ergySystem: "Energy System",
  newEnergySystemData: "Energy System Data",
  consumption: "Consumption",
  generation: "Generation",
  meter: "Meter",
  solarPower: "Hourly Generation",
  weatherData: "Weather Data",
};
